export const VIDEO_PLAYER_PORTAL_CONTAINER_ATTR = "data-video-player-portal"

export const VIDEO_PLAYER_PORTAL_CONTAINER_SELECTOR = `[${VIDEO_PLAYER_PORTAL_CONTAINER_ATTR}]`

/**
 * Prefer the fullscreen element (so menus stay visible in fullscreen),
 * then an explicit video-player portal host (e.g. a surrounding dialog),
 * otherwise fall back to the document body via Radix’s default.
 */
export function getVideoPlayerPortalContainer() {
  return (
    (document.fullscreenElement as HTMLElement | null) ??
    (document.querySelector(
      VIDEO_PLAYER_PORTAL_CONTAINER_SELECTOR
    ) as HTMLElement | null) ??
    undefined
  )
}
